'use client'

import { memo, useRef, type ReactNode } from 'react'
import './Clause.css'
import { useRegisterSidebarHighlighting } from '../Sidebar/Toc'
import { ErrorBoundary } from 'react-error-boundary'

interface Props {
  id?: string
  index: number
  children: ReactNode
}

const Clause = memo(function Clause({ id, children, index }: Props) {
  const ref = useRef<HTMLDivElement>(null)
  useRegisterSidebarHighlighting(ref, index)

  return (
    <ErrorBoundary fallbackRender={() => 'Ein Fehler ist aufgetreten'}>
      <section id={id} ref={ref}>
        {children}
      </section>
    </ErrorBoundary>
  )
})

export default Clause
